import localforage from "localforage";

localforage.config({
  driver: localforage.LOCALSTORAGE,
  storeName: "vikarn_client",
});

export default localforage;
